"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaGallery = void 0;
const basic_1 = require("../basic");
exports.mediaGallery = (0, basic_1.applyBase)({
    mediaGalleryStyles: {
        '.slider-control-centerleft': {
            left: '25px!important',
        },
        '.slider-control-centerright': {
            right: '25px!important',
        },
    },
    mediaGalleryModal: {
        '.modal-body': {
            maxWidth: '1185px',
            width: '100%',
            mx: 'auto',
            p: 4,
            py: [4, '40px'],
        },
    },
});
//# sourceMappingURL=media-gallery.js.map